// extracted by mini-css-extract-plugin
module.exports = {"Container":"TimerScreen_Container__2R2nC","Input":"TimerScreen_Input__1GIlJ"};